import { Link } from "react-router-dom";
import BrandMark from "../BrandMark";

const FooterComponent = () => (
  <footer className="site-footer">
    <div className="site-container footer-main">
      <div className="footer-brand">
        <Link className="brand" to="/" aria-label="CMJ Software home">
          <BrandMark />
          <span className="brand-name">
            CMJ <span>Software</span>
          </span>
        </Link>
        <p className="footer-summary">
          Strategy, design, and engineering for software that earns its place in
          your business.
        </p>
      </div>
      <div className="footer-column">
        <h3>Explore</h3>
        <Link to="/services">Services</Link>
        <Link to="/websites">Websites</Link>
        <Link to="/templates">Website service</Link>
        <Link to="/about">About</Link>
        <Link to="/pricing">Pricing</Link>
      </div>
      <div className="footer-column">
        <h3>Connect</h3>
        <Link to="/#contact">Request a quote</Link>
        <a href="https://www.instagram.com/cmjsoftware/" target="_blank" rel="noreferrer">
          Instagram
        </a>
        <a href="https://www.facebook.com/cmjsoftware" target="_blank" rel="noreferrer">
          Facebook
        </a>
      </div>
    </div>
    <div className="site-container footer-bottom">
      <span>© {new Date().getFullYear()} CMJ Software</span>
      <span>Built with care in Michigan.</span>
    </div>
  </footer>
);

export default FooterComponent;
